import './normalize.css';
import './index.sass';
import 'rxjs';
import './lib/getDataCy';
import '@rossum/ui/theme/fonts';
import { setupWorker } from 'msw/browser';
import { isIE } from 'react-device-detect';
import { createRoot } from 'react-dom/client';
import App from './containers/App';
import { handlersMap } from './mocks/browser';
import onLoadScript from './onLoadScripts';
import store from './redux/configureStore';

async function enableMocking() {
  if (!localStorage.getItem('mock_server_enabled')) {
    return undefined;
  }

  const mockServerScenario = localStorage.getItem('mock_server_scenario') ?? '';

  const mockServerHandlers = handlersMap[mockServerScenario];

  if (!mockServerHandlers) {
    return undefined;
  }

  const worker = setupWorker(...mockServerHandlers);

  return worker.start();
}

if (!isIE) {
  enableMocking().then(() => {
    onLoadScript(store);
    const root = createRoot(document.getElementById('root'));
    root.render(<App />);
  });
}
